export default function SubAbasFluxosAdmin(id: string) {
  if (id !== 'undefined') {
    return [
      {
        label: 'Dados Gerais',
        rota: `/daf/adm/fluxos-adm/modelo/${id}/dadosgerais`,
      },
    ];
  }

  return [
    {
      label: 'Dados Gerais',
      rota: '/daf/adm/fluxos-adm/modelo/dadosgerais',
    },
  ];
}
